export const getResponsiveSliceConfig = (width) => {
  if (width >= 1451 && width < 1600) {
    return { MRN: 8, "Episode ID": 8, Status: 12, Speciality: 8 };
  } else if (width >= 1600 && width < 1750) {
    return { MRN: 12, "Episode ID": 12, Status: 16, Speciality: 12 };
  } else if (width >= 1750 && width < 1900) {
    return { MRN: 15, "Episode ID": 15, Status: 20, Speciality: 15 };
  } else if (width >= 1900 && width < 2100) {
    return { MRN: 20, "Episode ID": 20, Status: 25, Speciality: 20 };
  } else if (width >= 2100 && width < 2400) {
    return { MRN: 26, "Episode ID": 26, Status: 38, Speciality: 20 };
  } else if (width >= 2400 && width < 2500) {
    return { MRN: 26, "Episode ID": 26, Status: 50, Speciality: 20 };
  } else if (width >= 2500 && width <= 2999) {
    return { MRN: 30, "Episode ID": 30, Status: 50, Speciality: 24 };
  } else if (width >= 2999) {
    return { MRN: 50, "Episode ID": 50, Status: 50, Speciality: 50 };
  } else {
    return { MRN: 4, "Episode ID": 4, Status: 4, Speciality: 4 };
  }
};